module.exports = window["wp"]["interactivityRouter"];